import { FC } from 'react';
import { Bell } from 'lucide-react';
import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { FeatureGuard } from '@/components/feature-guard';
import { useLaunchDarkly } from '@/providers/launchdarkly-provider';
import { useGetNotifications } from '@/hooks/queries/use-get-notifications';
import { useNotificationCenterStore } from '@/stores/notification-center-store';
import { NotificationCenter } from './notification-center';
import { NotificationPreferencesModal } from './notification-preferences-modal';
import { NotificationToaster } from './notification-toaster';

const NotificationBellInner: FC = () => {
  const toggle = useNotificationCenterStore((s) => s.toggle);
  const { data } = useGetNotifications();
  const unreadCount = data?.unread_count ?? 0;
  const badgeLabel = unreadCount > 99 ? '99+' : String(unreadCount);

  return (
    <>
      <SidebarMenuItem>
        <SidebarMenuButton
          tooltip='Activity'
          onClick={toggle}
          className='relative'
        >
          <Bell />
          <span>Activity</span>
          {unreadCount > 0 && (
            <>
              <span className='absolute right-2 top-1/2 inline-flex min-w-4 -translate-y-1/2 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold leading-4 text-primary-foreground group-data-[collapsible=icon]:hidden'>
                {badgeLabel}
              </span>
              <span className='absolute right-1.5 top-1 hidden size-2.5 rounded-full bg-primary group-data-[collapsible=icon]:block' />
            </>
          )}
        </SidebarMenuButton>
      </SidebarMenuItem>
      <NotificationCenter />
      <NotificationPreferencesModal />
      <NotificationToaster />
    </>
  );
};

export const NotificationBell: FC = () => {
  const { isNotificationCenterEnabled } = useLaunchDarkly();

  return (
    <FeatureGuard isEnabled={isNotificationCenterEnabled} fallback={null}>
      <NotificationBellInner />
    </FeatureGuard>
  );
};
